






import Vue, { PropType } from 'vue';
import FilterItem from './FilterItem.vue';

export default Vue.extend({
  name: 'FilterItems',
  components: {
    FilterItem,
  },
  props: {
    items: { // selected Items
      type: Array as PropType<string[]>,
      default: [],
    },
    removeItem: Function,
  },
});
